function parseCollectionHandles(raw) {
  return String(raw || '')
    .split('+')
    .map(function (h) {
      return h.trim();
    })
    .filter(Boolean);
}

function countLiveUpcomingLotsForHandle(handle) {
  if (!handle) return 0;
  var nowSec = Math.floor(Date.now() / 1000);
  // The catalogue card outlives its last lot by the hold window -- otherwise it
  // disappears the second that lot closes while the lot is still on the catalogue
  // page for another 24h. Read from sta-auctions-api.js so the two cannot drift.
  var holdSec = Math.floor((window.staEndedLotHoldMs || 24 * 60 * 60 * 1000) / 1000);
  var count = 0;
  document.querySelectorAll('ul.urls-check-cards-products li[data-product-id]').forEach(function (li) {
    var handleList = parseCollectionHandles(li.getAttribute('data-collection-handles-of-products'));
    if (handleList.indexOf(handle) === -1) return;
    var startTs = parseInt(li.getAttribute('data-auction-start-ts') || '0', 10) || 0;
    var endTs = parseInt(li.getAttribute('data-auction-end-ts') || '0', 10) || 0;
    if (!startTs || !endTs) return;
    // An unsold lot becomes Buy Now the moment its auction ends but stays on the
    // catalogue page for the hold, so it keeps counting until the hold is over.
    if (li.getAttribute('data-buy-now') === 'true' && endTs > nowSec) return;
    // A closed lot still counts for the length of the hold, so the catalogue keeps its
    // card for exactly as long as its lots keep their place on the catalogue page.
    if (endTs <= nowSec) {
      if (nowSec - endTs < holdSec) count++;
      return;
    }
    if (startTs <= nowSec && nowSec < endTs) count++;
    else if (nowSec < startTs) count++;
  });
  return count;
}

function formatCatalogueLotCountLabel(n) {
  n = n == null || isNaN(+n) ? 0 : +n;
  return n === 1 ? '1 Lot' : n + ' Lots';
}

function syncCatalogueCardLotCounts() {
  document.querySelectorAll('[data-catalogue-lot-count]').forEach(function (el) {
    var handle = (el.getAttribute('data-catalogue-lot-count') || '').trim();
    if (!handle) return;
    var n = countLiveUpcomingLotsForHandle(handle);
    el.textContent = formatCatalogueLotCountLabel(n);
    var slide = el.closest('[data-catalogue-carousel-slide], .sta-products-grid__cell, .sta-products-carousel__product.swiper-slide');
    if (!slide) return;
    if (n <= 0) {
      slide.hidden = true;
      slide.style.display = 'none';
    } else {
      slide.hidden = false;
      slide.style.display = '';
    }
  });
}

window.staSyncCatalogueCardLotCounts = syncCatalogueCardLotCounts;

document.querySelectorAll('[data-hero-slider]').forEach(heroSlider => {
  const sliderEl = heroSlider.querySelector('.swiper')
  const indexEl = heroSlider.querySelector('[data-slider-index]')
  const prevBtn = heroSlider.querySelector('[data-slider-prev]')
  const nextBtn = heroSlider.querySelector('[data-slider-next]')

  const swiper = new Swiper(sliderEl, {
    spaceBetween: 0,
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    speed: 1000,
    allowTouchMove: false,
    loop: true,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    autoplay: {
      delay: 7000,
      disableOnInteraction: true
    }
  })

  swiper.on('slideChange', (instance) => {
    let idx = isNaN(instance.realIndex) ? 0 : instance.realIndex
    if (indexEl) indexEl.innerText = String(++idx).padStart(2, '0')
  })
})

document.querySelectorAll('[data-departments-slider]').forEach(sliderEl => {
  const paginationEl = sliderEl.querySelector('[data-slider-pagination]')

  const swiper = new Swiper(sliderEl, {
    spaceBetween: 20,
    slidesPerView: 2,
    breakpoints: {
      750: {
        slidesPerView: 3,
      },
      990: {
        slidesPerView: 5,
      }
    },
    pagination: {
      el: paginationEl,
      clickable: true,
      bulletElement: 'button'
    }
  })
})

document.querySelectorAll('[data-specialists-slider]').forEach(specialistsEl => {
  const sliderEl = specialistsEl.querySelector('.swiper')
  const indexEl = specialistsEl.querySelector('[data-slider-index]')
  const prevBtn = specialistsEl.querySelector('[data-slider-prev]')
  const nextBtn = specialistsEl.querySelector('[data-slider-next]')

  const swiper = new Swiper(sliderEl, {
    spaceBetween: 20,
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    }
  })

  swiper.on('slideChange', (instance) => {
    let idx = isNaN(instance.realIndex) ? 0 : instance.realIndex
    if (indexEl) indexEl.innerText = ++idx
  })
})

// document.querySelectorAll('[data-products-slider]').forEach(productsEl => {
//   const sliderEl = productsEl.querySelector('[data-products-swiper]')
//   const prevBtn = productsEl.querySelector('[data-slider-prev]')
//   const nextBtn = productsEl.querySelector('[data-slider-next]')

//   if (sliderEl) {
//     const swiper = new Swiper(sliderEl, {
//       spaceBetween: 16,
//       slidesPerView: 1.09,
//       loop: false,
//       breakpoints: {
//         480: {
//           slidesPerView: 2,
//         },
//         750: {
//           slidesPerView: 3,
//           spaceBetween: 24,
//         },
//         990: {
//           slidesPerView: 4,
//           spaceBetween: 24,
//         }
//       },
//       navigation: {
//         nextEl: nextBtn,
//         prevEl: prevBtn,
//       }
//     })
//   }
// })

// ---------- helpers ----------
function createSlide(src, width = 175, height = 175) {
  const slide = document.createElement('div');
  slide.className = 'sta-product-card__carousel-image swiper-slide';
  const img = document.createElement('img');
  img.src = src;
  img.alt = '';
  img.width = width;
  img.height = height;
  img.loading = 'lazy';
  slide.appendChild(img);
  return slide;
}

async function fetchJSON(url) {
  let fetchOpts = { credentials: 'same-origin', mode: 'cors' };
  let isExternal = false;
  try {
    const resolved = new URL(url, window.location.href);
    if (resolved.origin !== window.location.origin) {
      fetchOpts = { credentials: 'omit', mode: 'cors' };
      isExternal = true;
    }
  } catch {
    fetchOpts = { credentials: 'omit', mode: 'cors' };
    isExternal = true;
  }
  if (isExternal && window.staAuctionHeaders) {
    fetchOpts.headers = window.staAuctionHeaders();
  }
  const res = await fetch(url, fetchOpts);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

function resolveAuctionsApiBase() {
  if (window.staAuctionsBase) return window.staAuctionsBase();
  const raw = localStorage.getItem('sterlings_base_url');
  const trimmed = raw && String(raw).replace(/\/+$/, '');
  if (trimmed) return trimmed;
  return 'https://productauctions.herokuapp.com';
}

function productNumericId(platformProductId) {
  if (platformProductId == null || platformProductId === '') return '';
  const s = String(platformProductId).trim();
  if (s.includes('/')) return s.split('/').pop() || '';
  return s.replace(/\D/g, '') || s;
}

/** Comma-separated Shopify product ids from Liquid (data-past-product-ids). */
function parsePastProductIdSet(block) {
  const raw = (block.dataset.pastProductIds || '').trim();
  if (!raw) return null;
  const set = new Set(
    raw
      .split(',')
      .map((s) => String(s.trim()))
      .filter(Boolean)
  );
  return set.size ? set : null;
}

function isLiveAuction(row) {
  const a = row?.attributes || row || {};
  const s = String(a.status || '').toLowerCase();
  if (/disabled|ended|archive|complete|cancel/.test(s)) return false;
  if (['live', 'running', 'open'].some((k) => s.includes(k))) return true;
  const now = Date.now();
  const sd = Date.parse(a.start_date || a.start_at || '');
  const ed = Date.parse(a.end_date || a.end_at || '');
  if (Number.isFinite(sd) && Number.isFinite(ed)) return sd <= now && now < ed;
  return false;
}

/** JSON:API auction row: truly live by dates + status (matches collection grid logic). */
function isLiveAuctionApiRow(row) {
  const a = row?.attributes || row || {};
  const status = String(a.status || '').toLowerCase();
  const now = Date.now();
  const sd = Date.parse(a.start_date || a.start_at || '');
  const ed = Date.parse(a.end_date || a.end_at || '');
  if (!Number.isFinite(sd) || !Number.isFinite(ed)) return false;
  if (!(sd <= now && now < ed)) return false;
  if (/disabled|ended|archive|complete|cancel/.test(status)) return false;
  return true;
}

function escapeHTML(s) {
  return String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function formatEnds(dateStr) {
  const d = new Date(dateStr);
  if (isNaN(d)) return '';
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
}

function diffDH(endStr) {
  const end = Date.parse(endStr);
  if (Number.isNaN(end)) return { days: 0, hours: 0 };
  let secs = Math.max(0, Math.floor((end - Date.now()) / 1000));
  const days = Math.floor(secs / 86400);
  secs -= days * 86400;
  const hours = Math.floor(secs / 3600);
  return { days, hours };
}

/**
 * Past-auction row belongs to this Shopify auction collection (handle and/or title),
 * via API shopify_collections / primary_catalog_collection or hidden product map in theme.liquid.
 */
function rowBelongsToAuctionCollection(row, handle, collectionTitle) {
  const h = String(handle || '').trim().toLowerCase();
  const t = String(collectionTitle || '').trim().toLowerCase();
  if (!h && !t) return true;

  const a = row?.attributes || row || {};
  const primary = a.primary_catalog_collection;
  if (primary) {
    if (h && String(primary.handle || '').toLowerCase() === h) return true;
    if (t && String(primary.title || '').trim().toLowerCase() === t) return true;
  }
  const cols = a.shopify_collections || [];
  if (Array.isArray(cols)) {
    for (const c of cols) {
      if (h && String(c.handle || '').toLowerCase() === h) return true;
      if (t && String(c.title || '').trim().toLowerCase() === t) return true;
    }
  }

  const pid = productNumericId(a.platform_product_id);
  if (!pid) return false;
  const li = document.querySelector(`ul.urls-check-cards-products li[data-product-id="${pid}"]`);
  if (!li) return false;
  const handlesRaw = li.getAttribute('data-collection-handles-of-products') || '';
  const titlesRaw = li.getAttribute('data-collection-of-products') || '';
  const handles = handlesRaw.split('+').map((s) => s.trim().toLowerCase()).filter(Boolean);
  const titles = titlesRaw.split('+').map((s) => s.trim().toLowerCase()).filter(Boolean);
  if (h && handles.includes(h)) return true;
  if (t && titles.includes(t)) return true;
  return false;
}

let liveAuctionsForCountsPromise = null;
function fetchLiveAuctionsDataOnce(base) {
  if (!liveAuctionsForCountsPromise) {
    const b = String(base || '').replace(/\/$/, '');
    const url = `${b}/api/auctions`;
    liveAuctionsForCountsPromise = fetchJSON(url).catch((err) => {
      console.warn('[collection-slider] live auctions fetch failed', err);
      return { data: [] };
    });
  }
  return liveAuctionsForCountsPromise;
}

function updateLiveLotCountsFromAuctions(allAuctions) {
  const allAuctionCollectionCount = {};
  (allAuctions || []).forEach((auction) => {
    const productName = auction?.attributes?.auction_name;
    const productId = auction?.attributes?.platform_product_id;
    const cleanProductId = productId?.split('/').pop();
    const li = document.querySelector(`ul.urls-check-cards-products li[data-product-id="${cleanProductId}"]`);
    if (li) {
      const collectionTitle = li.getAttribute('data-collection-of-products') || 'Unknown Collection';
      allAuctionCollectionCount[productName] = collectionTitle;
    }
  });
  const collectionCounts = {};
  Object.values(allAuctionCollectionCount).forEach((collectionString) => {
    const collections = collectionString.split('+').map((c) => c.trim()).filter(Boolean);
    collections.forEach((name) => {
      collectionCounts[name] = (collectionCounts[name] || 0) + 1;
    });
  });
  document.querySelectorAll('[data-collection-count]').forEach((el) => {
    if (el.closest('.sta-collection-hero')) return;
    if (el.closest('[data-live-catalogues-carousel]')) return;
    if (el.hasAttribute('data-catalogue-lot-count')) return;
    const carousel = el.closest('[data-carousel-auctions-source]');
    if (
      carousel &&
      (carousel.getAttribute('data-carousel-auctions-source') || 'live').toLowerCase() === 'past'
    )
      return;
    const card = el.closest('[data-collection-products-slider]');
    if ((card?.dataset.auctionsSource || 'live').toLowerCase() === 'past') return;
    const collectionName = (el.getAttribute('data-collection-count') || '').trim();
    const count = collectionCounts[collectionName] || 0;
    const text = count === 1 ? '1 lot' : `${count} lots`;
    el.textContent = text;
  });
}

function formatMoney(n) {
  if (n == null || isNaN(Number(n))) return '';
  if (window.staFormatMoney) return window.staFormatMoney(Number(n));
  return '<small>$</small>' + Number(n).toLocaleString('en-US') + '<span class="sta-money__code"> CAD</span>';
}

function toProductUrl(input, auctionId, opts = {}) {
  if (!input) return '';

  // Decide the base: prefer Shopify shop domain, then opts.base, then current origin
  const base = "https://sterlingauctions.myshopify.com"
  let url;

  // Already a URL or a /products/... path?
  if (/^(https?:)?\/\//i.test(input)) {
    url = input + `?auction_id=${auctionId}`;
  } else {
    url = base + "/products/" + input + `?auction_id=${auctionId}`
  }

  return url;
}

function startCountdown(bodyEl, endIso){
    var p = bodyEl.querySelector('p'); if (!p) { p = document.createElement('p'); bodyEl.appendChild(p); }
    function render(){
      var end = Date.parse(endIso || '');
      if (!isFinite(end)) { p.textContent = ''; return; }
      var s = Math.max(0, Math.floor((end - Date.now())/1000));
      var d = Math.floor(s/86400); s -= d*86400;
      var h = Math.floor(s/3600);  s -= h*3600;
      var m = Math.floor(s/60);    var sec = s%60;
      if (d+h+m+sec<=0) p.textContent = 'Ended';
      else p.textContent = d+'d '+String(h).padStart(2,'0')+'h '+String(m).padStart(2,'0')+'m '+String(sec).padStart(2,'0')+'s';
    }
    render();
    var t = setInterval(render,1000);
    var mo = new MutationObserver(function(){
      if (!document.body.contains(bodyEl)) { clearInterval(t); mo.disconnect(); }
    });
    mo.observe(document.body,{childList:true,subtree:true});
  }

function createSlideCard(item, fallbackImg) {
  const imgSrc = item.attributes.product_image_url;
  const href = item.attributes.product_url;
  const title = item.attributes.product_title;
  const sku = item.attributes.product_sku;
  const endStr = item.attributes.end_date;
  const endsTxt = endStr ? formatEnds(endStr) : '';
  const { days, hours } = diffDH(endStr);
  const pid = productNumericId(item.attributes.platform_product_id);
  const storeDollars = pid && window.staStorePriceDollars ? window.staStorePriceDollars(pid) : null;
  const buyNow = window.staAuctionDisplayPrice
    ? window.staAuctionDisplayPrice(item.attributes, storeDollars)
    : item.attributes.current_price != null
      ? item.attributes.current_price
      : item.attributes.starting_price != null
        ? item.attributes.starting_price
        : item.attributes.initial_price != null
          ? item.attributes.initial_price
          : storeDollars;
  const bids = item.attributes.bids_count;
  const bidNum = parseInt(bids, 10) || 0;
  const livePriceLabel = window.staAuctionLivePriceLabel
    ? window.staAuctionLivePriceLabel(bidNum)
    : bidNum > 0
      ? 'Current bid:'
      : 'Starting bid:';

  // Optional: auction/collection info if you expose it in middleware
  const auctionTitle = item.attributes.auction_name || '';
  const auctionUrl = toProductUrl(item.attributes.product_url, item.id );

  if (endStr) {
    var d = new Date(endStr);
    d = 'Ends ' + d.toLocaleDateString();
  }

  const liveBadge = isLiveAuction(item)
    ? `
      <span class="sta-product-card__badge sta-product-badge _live">
        <span class="sta-product-badge__name">Live</span>
      </span>`
    : '';

  const estimateRaw =
    pid && window.staGetPriceEstimateForProductId ? window.staGetPriceEstimateForProductId(pid) : '';
  const estimateHtml =
    estimateRaw && window.staFormatPriceEstimateCardHtml
      ? window.staFormatPriceEstimateCardHtml(estimateRaw)
      : '';
  const infoRowClass = estimateHtml
    ? 'sta-product-card__info-row'
    : 'sta-product-card__info-row sta-product-card__info-row--no-estimate';

  return `
<div class="sta-products-carousel__product swiper-slide">
<div class="sta-product-card">
  <div class="sta-product-card__header">
    <a href="${escapeHTML(href)}" class="sta-product-card__ill">
      ${imgSrc
        ? `<img src="${escapeHTML(imgSrc)}" alt="${escapeHTML(title)}" width="186" height="206" loading="lazy" class="sta-product-card__img" />`
        : ''
      }
    </a>
    ${liveBadge}
    <button class="sta-product-card__to-wish sta-wish-btn" title="Add to wishlist"></button>
  </div>

  <div class="sta-product-card__body">
    <h3 class="sta-product-card__title"><a href="${escapeHTML(href)}">${escapeHTML(title)}</a></h3>
    ${auctionTitle
      ? `<div class="sta-product-card__auction">
            <a href="${escapeHTML(auctionUrl)}">${escapeHTML(auctionTitle)}</a>
          </div>`
      : ''
    }
  </div>

  <div class="sta-product-card__info">
    <div class="${infoRowClass}">
    <div class="sta-product-specs">
      ${sku
        ? `<div class="sta-product-spec">
              <span class="sta-product-spec__ico"></span>
              <div class="sta-product-spec__body">
                <div class="sta-product-spec__title">SKU: ${escapeHTML(sku)}</div>
              </div>
            </div>`
        : ''
      }

      ${endStr
        ? `<div class="sta-product-spec countdown">
              <svg class="svg-ico sta-product-spec__ico">
                <use xlink:href="${escapeHTML(window.theme?.spriteUrl || '/cdn/shop/t/3/assets/sprite.svg')}#stopwatch"></use>
              </svg>
              <div class="sta-product-spec__body">
                <div class="sta-product-spec__title">
                  ${d}
                </div>
              </div>
            </div>`
        : ''
      }
    </div>
    <div class="sta-product-card__estimate-slot" data-price-estimate-slot${estimateHtml ? '' : ' hidden'}>
      ${estimateHtml}
    </div>
    </div>
  </div>

  <div class="sta-product-card__footer">
    <div class="sta-product-card__price">
      <div class="sta-product-spec__body sta-product-price">
        <div class="sta-product-price__title">${livePriceLabel}</div>
        <div class="sta-product-price__price">${buyNow != null ? formatMoney(buyNow) : ''}</div>
      </div>
      <div class="sta-product-card__bids">
        <svg class="svg-ico sta-product-card__bids-ico">
          <use xlink:href="${escapeHTML(window.theme?.spriteUrl || '/cdn/shop/t/3/assets/sprite.svg')}#auction-hammer"></use>
        </svg>
        <div class="sta-product-card__bids-body">
          <div class="sta-product-card__bids-count">${Number(bids) || 0}</div>
          <div>${(Number(bids) || 0) === 1 ? 'Bid' : 'Bids'}</div>
        </div>
      </div>
    </div>
    <a href="${auctionUrl}" class="sta-btn _secondary _full center">Place Bid</a>
  </div>
</div>
</div>`;
}

// ---------- product carousels (manual products + live auctions) ----------
function bootProductsSliders() {
  document.querySelectorAll('[data-products-slider]').forEach(function (productsEl) {
    if (productsEl.getAttribute('data-sta-products-slider-ready') === 'true') return;

    var sliderEl = productsEl.querySelector('[data-products-swiper]');
    var wrapper = productsEl.querySelector('[data-products-swiper] .sta-products-carousel__list.swiper-wrapper');
    var prevBtn = productsEl.querySelector('[data-slider-prev]');
    var nextBtn = productsEl.querySelector('[data-slider-next]');

    if (!sliderEl || !wrapper) return;

    if (productsEl.hasAttribute('data-live-auctions-slider')) {
      if (productsEl.getAttribute('data-sta-live-hydrate-started') === 'true') return;
      productsEl.setAttribute('data-sta-live-hydrate-started', 'true');
      var hydrateMode =
        (productsEl.getAttribute('data-auctions-slider-mode') || 'live').toLowerCase() === 'upcoming'
          ? 'upcoming'
          : 'live';
      var attempts = 0;
      function tryHydrateLive() {
        if (window.staLiveAuctionLots && window.staLiveAuctionLots.hydrateLiveAuctionsCarousel) {
          window.staLiveAuctionLots.hydrateLiveAuctionsCarousel(sliderEl, wrapper, prevBtn, nextBtn, hydrateMode).then(function () {
            productsEl.setAttribute('data-sta-products-slider-ready', 'true');
          });
          return;
        }
        attempts += 1;
        if (attempts < 60) setTimeout(tryHydrateLive, 50);
      }
      tryHydrateLive();
      return;
    }

    if (wrapper.querySelector('.sta-products-carousel__product')) {
      if (window.staLiveAuctionLots && window.staLiveAuctionLots.initProductsSwiper) {
        window.staLiveAuctionLots.initProductsSwiper(sliderEl, prevBtn, nextBtn);
      } else if (typeof Swiper !== 'undefined') {
        new Swiper(sliderEl, {
          spaceBetween: 16,
          slidesPerView: 1.09,
          loop: false,
          breakpoints: {
            480: { slidesPerView: 2 },
            750: { slidesPerView: 3, spaceBetween: 24 },
            990: { slidesPerView: 4, spaceBetween: 24 },
          },
          navigation: { nextEl: nextBtn, prevEl: prevBtn },
        });
      }
      productsEl.setAttribute('data-sta-products-slider-ready', 'true');
    }
  });
}

document.addEventListener('DOMContentLoaded', bootProductsSliders);
window.addEventListener('load', bootProductsSliders);


document.querySelectorAll('[data-collections-slider]').forEach(collectionsEl => {
  const mobileSliderEl = collectionsEl.querySelector('[data-collections-mobile-swiper]')
  const desktopSliderEl = collectionsEl.querySelector('[data-collections-swiper]')
  const prevBtn = collectionsEl.querySelector('[data-slider-prev]')
  const nextBtn = collectionsEl.querySelector('[data-slider-next]')
  const mobilePrevBtn = collectionsEl.querySelector('[data-slider-mobile-prev]')
  const mobileNextBtn = collectionsEl.querySelector('[data-slider-mobile-next]')

  if (desktopSliderEl) {
    const desktopSwiper = new Swiper(desktopSliderEl, {
      spaceBetween: 20,
      slidesPerView: 1,
      loop: false,
      autoHeight: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      }
    })
  }

  if (mobileSliderEl) {
    const swiper = new Swiper(mobileSliderEl, {
      spaceBetween: 16,
      slidesPerView: 1.09,
      loop: false,
      breakpoints: {
        480: {
          slidesPerView: 2,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 24,
        }
      },
      navigation: {
        nextEl: mobileNextBtn,
        prevEl: mobilePrevBtn,
      }
    })
  }
})

// ---- main ----
document.addEventListener('DOMContentLoaded', async function () {
  const blocks = document.querySelectorAll('[data-collection-products-slider]');

  for (const block of blocks) {
    const base = resolveAuctionsApiBase();
    const source = (block.dataset.auctionsSource || 'live').toLowerCase();
    const collectionHandle = (block.dataset.collectionHandle || '').trim();
    const collectionTitle = (block.dataset.collectionTitle || '').trim();

    const endpoint = `${base}/api/auctions`;

    const fallback = block.dataset.fallbackImage || '';
    const swiperEl = block.querySelector('[data-collection-products-swiper]');
    const wrapper = swiperEl && swiperEl.querySelector('.swiper-wrapper');
    const totalCountsBlock = block.querySelector('.slider-items-total-count');
    if (!wrapper) continue;

    wrapper.innerHTML = '';

    try {
      const data = await fetchJSON(endpoint);
      let rows = Array.isArray(data) ? data : (data.data || []);
      if (source === 'past') {
        if (window.staFilterPastAuctionRows) {
          rows = window.staFilterPastAuctionRows(rows);
        }
        const idSet = parsePastProductIdSet(block);
        if (idSet) {
          rows = rows.filter((row) => {
            const pid = productNumericId(row.attributes?.platform_product_id);
            return pid && idSet.has(String(pid));
          });
        } else if (collectionHandle || collectionTitle) {
          rows = rows.filter((row) =>
            rowBelongsToAuctionCollection(row, collectionHandle, collectionTitle)
          );
        }
      } else if (source === 'live') {
        rows = rows.filter(isLiveAuctionApiRow);
        if (collectionHandle || collectionTitle) {
          rows = rows.filter((row) =>
            rowBelongsToAuctionCollection(row, collectionHandle, collectionTitle)
          );
        }
        const seenPid = new Set();
        rows = rows.filter((row) => {
          const pid = String(row.attributes?.platform_product_id || '');
          if (!pid || seenPid.has(pid)) return false;
          seenPid.add(pid);
          return true;
        });
      }

      const live = rows.slice(0, 14);

      if (live.length === 0) {
        if (fallback) wrapper.appendChild(createSlide(fallback));
        if (totalCountsBlock) totalCountsBlock.textContent = '1';
      } else {
        live.forEach((item) => {
          const imgSrc = item.attributes?.product_image_url || fallback;
          wrapper.appendChild(createSlide(imgSrc || fallback));
        });
        if (totalCountsBlock) totalCountsBlock.textContent = String(live.length);
      }

      const indexEl = block.querySelector('[data-slider-index]');
      const prevBtn = block.querySelector('[data-slider-inner-prev]');
      const nextBtn = block.querySelector('[data-slider-inner-next]');

      if (source === 'live') {
        fetchLiveAuctionsDataOnce(base).then((d) => {
          const allAuctions = d?.data || [];
          updateLiveLotCountsFromAuctions(allAuctions);
        });
      }

      if (swiperEl && typeof Swiper !== 'undefined') {
        const swiper = new Swiper(swiperEl, {
          spaceBetween: 0,
          slidesPerView: 1,
          autoHeight: false,
          loop: true,
          navigation: { nextEl: nextBtn, prevEl: prevBtn }
        });

        swiper.on('slideChange', (instance) => {
          let idx = isNaN(instance.realIndex) ? 0 : instance.realIndex;
          if (indexEl) indexEl.innerText = ++idx;
        });
      }
    } catch (err) {
      console.error('Failed to load collection auction slider:', err);
      if (fallback) wrapper.appendChild(createSlide(fallback));
    }
  }
});


document.querySelectorAll('[data-blog-posts-slider]').forEach(productsEl => {
  const sliderEl = productsEl.querySelector('[data-products-swiper]')
  const prevBtn = productsEl.querySelector('[data-slider-prev]')
  const nextBtn = productsEl.querySelector('[data-slider-next]')

  if (sliderEl) {
    const swiper = new Swiper(sliderEl, {
      spaceBetween: 16,
      slidesPerView: 1.09,
      loop: false,
      breakpoints: {
        480: {
          slidesPerView: 2,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 24,
        }
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      }
    })
  }
})

syncCatalogueCardLotCounts();
setTimeout(syncCatalogueCardLotCounts, 1500);

syncCatalogueCardLotCounts();
setTimeout(syncCatalogueCardLotCounts, 1500);
